import { provideHealthcheck } from '@atlassian/jira-common-healthcheck';
import global from './global';

global.install();
provideHealthcheck();
